"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaybePromise = exports.transformMaybePromise = void 0;
const isPromise_js_1 = require("./isPromise.js");
function transformMaybePromise(value, transformer) {
    return (0, isPromise_js_1.isPromise)(value) ? value.then(transformer) : transformer(value);
}
exports.transformMaybePromise = transformMaybePromise;
exports.MaybePromise = {
    transform: transformMaybePromise
};
//# sourceMappingURL=MaybePromise.js.map